// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/29392
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 29392 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  Shop_Main: 'Shop_Main'
})

interface IPVTrackParamsRecord {
  /** 店铺落地页 */
Shop_Main: {
/** 店铺id  */
shopid: string}
}

const sendPv = {
  /** PV-店铺落地页 */
Shop_Main: (page_param: IPVTrackParamsRecord['Shop_Main']) => {
    eventTrackingUtils.submitPV({page_id:PageId.Shop_Main,page_param});
  },
}

interface IExpoTrackParamsRecord {
  /** 店铺头部logo名称曝光 */
Shop_Main_Head_LogoName_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行一图片 */
Shop_Main_Image1_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行一视频 */
Shop_Main_Video1_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行三图片文字卡片组件 */
Shop_Main_ImageCard3_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行三视频文字卡片组件 */
Shop_Main_VideoCard3_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 小标题组件 */
Shop_Main_Subtitle_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 横划商品池组件 */
Shop_Main_ProductPool_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 导航条 */
Shop_Main_NavigationBar_Expo: {
/** 店铺id  */
shopid: string,
/** 位置  */
index: number,
/** tab对应的类目id  */
cat_id: string}
  /** 商品曝光 */
Shop_Main_Product_Expo: {
/** 店铺id  */
shopid: string,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string}
  /** 加车数量 */
Shop_Main_Product_Num_Expo: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string,
/** 模块实例ID  */
moduleInstanceId: string,
/** 数量  */
num: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 店铺头部logo名称曝光 */
  Shop_Main_Head_LogoName_Expo:'Shop_Main_Head_LogoName_Expo',
/** 一行一图片 */
  Shop_Main_Image1_Expo:'Shop_Main_Image1_Expo',
/** 一行一视频 */
  Shop_Main_Video1_Expo:'Shop_Main_Video1_Expo',
/** 一行三图片文字卡片组件 */
  Shop_Main_ImageCard3_Expo:'Shop_Main_ImageCard3_Expo',
/** 一行三视频文字卡片组件 */
  Shop_Main_VideoCard3_Expo:'Shop_Main_VideoCard3_Expo',
/** 小标题组件 */
  Shop_Main_Subtitle_Expo:'Shop_Main_Subtitle_Expo',
/** 横划商品池组件 */
  Shop_Main_ProductPool_Expo:'Shop_Main_ProductPool_Expo',
/** 导航条 */
  Shop_Main_NavigationBar_Expo:'Shop_Main_NavigationBar_Expo',
/** 商品曝光 */
  Shop_Main_Product_Expo:'Shop_Main_Product_Expo',
/** 加车数量 */
  Shop_Main_Product_Num_Expo:'Shop_Main_Product_Num_Expo',
})

interface IClickTrackParamsRecord {
  /** 一行一图片 */
Shop_Main_Image1: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行一视频 */
Shop_Main_Video1: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行三图片文字卡片组件 */
Shop_Main_ImageCard3: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 一行三视频文字卡片组件 */
Shop_Main_VideoCard3: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 链接信息  */
url: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 横划商品池组件 */
Shop_Main_ProductPool: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string,
/** 模块实例ID  */
moduleInstanceId: string}
  /** 导航条 */
Shop_Main_NavigationBar: {
/** 店铺id  */
shopid: string,
/** 位置  */
index: number,
/** tab对应的类目id  */
cat_id: string}
  /** 商品点击 */
Shop_Main_Product: {
/** 店铺id  */
shopid: string,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string}
  /** 商品加购 */
Shop_Main_Product_Addtocart: {
/** 店铺id  */
shopid: string,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string}
  /** 点击加车 */
Shop_Main_ProductPool_Addtocart: {
/** 店铺id  */
shopid: string,
/** 位置  */
index: number,
/** 第一价格金额  */
firprice: number,
/** 第二价格金额  */
secprice: number,
/** 星级评级  */
ratingNum: string,
/** 销售量  */
SalesNum: string,
/** 商品id  */
skuid: string}
  /** 横划商品池查看更多 */
Shop_Main_ProductPool_More: {
/** 店铺id  */
shopid: string,
/** 位置号  */
pos: number,
/** 模块实例ID  */
moduleInstanceId: string,
/** 链接信息  */
url: string}
}

const sendClickTrack = {
  /** 点击事件上报-一行一图片 */
Shop_Main_Image1: (json_param: IClickTrackParamsRecord['Shop_Main_Image1']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_Image1',json_param});
  },
  /** 点击事件上报-一行一视频 */
Shop_Main_Video1: (json_param: IClickTrackParamsRecord['Shop_Main_Video1']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_Video1',json_param});
  },
  /** 点击事件上报-一行三图片文字卡片组件 */
Shop_Main_ImageCard3: (json_param: IClickTrackParamsRecord['Shop_Main_ImageCard3']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_ImageCard3',json_param});
  },
  /** 点击事件上报-一行三视频文字卡片组件 */
Shop_Main_VideoCard3: (json_param: IClickTrackParamsRecord['Shop_Main_VideoCard3']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_VideoCard3',json_param});
  },
  /** 点击事件上报-横划商品池组件 */
Shop_Main_ProductPool: (json_param: IClickTrackParamsRecord['Shop_Main_ProductPool']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_ProductPool',json_param});
  },
  /** 点击事件上报-导航条 */
Shop_Main_NavigationBar: (json_param: IClickTrackParamsRecord['Shop_Main_NavigationBar']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_NavigationBar',json_param});
  },
  /** 点击事件上报-商品点击 */
Shop_Main_Product: (json_param: IClickTrackParamsRecord['Shop_Main_Product']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_Product',json_param});
  },
  /** 点击事件上报-商品加购 */
Shop_Main_Product_Addtocart: (json_param: IClickTrackParamsRecord['Shop_Main_Product_Addtocart']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_Product_Addtocart',json_param});
  },
  /** 点击事件上报-点击加车 */
Shop_Main_ProductPool_Addtocart: (json_param: IClickTrackParamsRecord['Shop_Main_ProductPool_Addtocart']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_ProductPool_Addtocart',json_param});
  },
  /** 点击事件上报-横划商品池查看更多 */
Shop_Main_ProductPool_More: (json_param: IClickTrackParamsRecord['Shop_Main_ProductPool_More']) => {
    eventTrackingUtils.submitCL({event_id:'Shop_Main_ProductPool_More',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}